import styled from "styled-components";

import theme from "config/theme";

import { H6 } from "components/Text";
import StyledImage from "components/Image";

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  z-index: 2;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  transform: translateY(10px);
  transition: ${theme.transition};

  @media (max-width: ${theme.size.tablet}) {
    padding: 15px;
  }
`;

export const Bio = styled.div`
  flex: 1;
  color: white;
  line-height: 1.4;
  max-width: 350px;
  margin-bottom: 0;
  font-size: 11px;

  @media (max-width: ${theme.size.tablet}) {
    font-size: ${theme.font.size.kappa};
  }
`;

export const Image = styled(StyledImage)`
  width: 100%;
  height: 300px;
  display: block;
  border-radius: ${theme.radius};
  transition: ${theme.transition};
`;

export const Social = styled.div`
  display: flex;
  align-items: center;

  a {
    margin-right: 15px;
    font-size: 20px;
    transition: ${theme.transition};

    &:hover {
      opacity: 0.7;
    }
  }
`;

export const Inner = styled.div`
  position: relative;
  border-radius: ${theme.radius};
  background-color: ${theme.color.gray2};
  transition: ${theme.transition};
`;

export const Wrapper = styled.div`
  margin: 3px;
  width: calc(25% - 6px);
  position: relative;

  @media (max-width: ${theme.size.desktop}) {
    width: calc(33% - 6px);
  }

  @media (max-width: ${theme.size.tablet}) {
    width: calc(50% - 6px);
  }

  @media (max-width: ${theme.size.mobile}) {
    width: calc(100% - 6px);
  }

  &:hover {
    ${Inner} {
      transform: scale(0.98) translateZ(0);
    }

    ${Image} {
      opacity: ${props => (props.hasInfo ? "0.15" : "1")};
    }

    ${Overlay} {
      transform: none;
      opacity: ${props => (props.hasInfo ? "1" : "0")};
    }
  }
`;

export const Details = styled.div`
  width: 100%;
  text-align: center;
  padding: 10px 15px 15px;

  @media (max-width: ${theme.size.tablet}) {
    padding-bottom: 0;
  }
`;

export const Name = styled(H6)`
  margin-bottom: 5px;
  line-height: 1.1;
`;

export const Role = styled.p`
  opacity: 0.7;
  line-height: 1.2;
  color: ${theme.color.gray3};
  font-size: ${theme.font.size.kappa};
`;
